<template>
  <application-modal v-model="showModal">
    <v-btn
      data-testid="request-uhaul-open-btn"
      class="request-uhaul-open-btn mr-4 primary px-3 white--text"
      slot="modal-trigger"
      outlined
      @click.stop="showModal = true"
    >
      <v-icon class="mr-3">email</v-icon>
      Request UHaul
    </v-btn>
    <div slot="modal-title">Request UHaul</div>
    <div slot="modal-body" ref="request-uhaul-modal-body">
      <validation-observer ref="observer" v-slot="{ invalid }">
        <v-form ref="request-uhaul-form" @submit.prevent>
          <app-input
            data-testid="request-uhaul-customer-name-input"
            class="request-uhaul-customer-name-input"
            v-model="customer_name"
            filled
            label="Customer full name"
            :rules="'required'"
          ></app-input>
          <app-input
            data-testid="request-uhaul-customer-phone-input"
            class="request-uhaul-customer-phone-input"
            v-model="customer_phone"
            filled
            label="Customer phone number"
            type="phone"
            :rules="'required|phone'"
          ></app-input>
          <app-input
            data-testid="request-uhaul-customer-email-input"
            class="request-uhaul-customer-email-input"
            v-model="customer_email"
            filled
            label="Customer email address"
            type="email"
            :rules="'required|email'"
          ></app-input>
          <v-textarea
            data-testid="request-uhaul-note-textarea"
            class="request-uhaul-note-textarea"
            v-model="note"
            filled
            label="Note"
          />
          <v-row justify="end">
            <v-col md="auto">
              <v-btn
                data-testid="request-uhaul-submit-btn"
                class="request-uhaul-submit-btn"
                :loading="requestLoading"
                :disabled="invalid"
                color="primary"
                @click="submitRequest"
                >Request UHaul</v-btn
              >
            </v-col>
          </v-row>
        </v-form>
      </validation-observer>
    </div>
  </application-modal>
</template>

<script>
import ApplicationModal from "@/components/ApplicationModal";
import { ValidationObserver } from "vee-validate";

export default {
  data() {
    return {
      customer_email: "",
      customer_name: "",
      customer_phone: "",
      showModal: false,
      email: "",
      note: "",
      formValid: false
    };
  },

  computed: {
    requestLoading() {
      return this.$store.state.facilities.requestUhaulLoading;
    }
  },

  methods: {
    submitRequest() {
      let payload = {
        customer_email: this.customer_email,
        customer_name: this.customer_name,
        customer_phone: this.customer_phone,
        note: this.note,
        facilityId: this.$route.params.facilityId
      };
      this.$store
        .dispatch("requestUhaul", payload)
        .then(() => {
          this.$store.dispatch("handleSuccess", "UHaul Request sent!");
          this.showModal = false;
        })
        .catch((err) => {
          this.$store.dispatch("handleError", err);
        });
    }
  },

  components: {
    ApplicationModal,
    ValidationObserver
  }
};
</script>
